import React, { useMemo } from 'react';
import Element from '../Element';
import { Element as ElementType } from '../../types';
import './ElementsList.css';

interface ElementsListProps {
  elements: ElementType[];
  onElementClick?: (element: ElementType) => void;
}

const ElementsList: React.FC<ElementsListProps> = ({ 
  elements, 
  onElementClick 
}) => {
  const sortedElements = useMemo(() => {
    return [...elements].sort((a, b) => a.name.localeCompare(b.name));
  }, [elements]);

  const handleElementClick = (element: ElementType) => {
    if (onElementClick) {
      onElementClick(element);
    }
  };

  return (        
    <div className="elements-list-content">
      {sortedElements.length > 0 ? (
        <div className="all-elements">
          {sortedElements.map(element => (
            <div key={element._id} onClick={() => handleElementClick(element)}>
              <Element
                element={element}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="elements-empty">
          Нет доступных элементов. Начните с базовых элементов!
        </div>
      )}
    </div>
  );
};

export default ElementsList; 